import { Modal } from '@models';
import { RcFile } from 'antd/lib/upload';
import { array, boolean, mixed, object, ObjectSchema, string } from 'yup';

export const paginationContentSchema: ObjectSchema<Modal.IPaginationContent> =
  object({
    urlLocalShow: string().required('Este campo é obrigatório'),
    modalContent: array()
      .of(
        object({
          id: string().optional(),
          mediaType: string().required('Este campo é obrigatório'),
          title: string().required('Este campo é obrigatório'),
          titleActivated: boolean().optional(),
          description: string().required('Este campo é obrigatório'),
          textButton: string().optional(),
          urlVideoModal: string().when('mediaType', {
            is: 'VIDEO',
            then: schema =>
              schema.required(
                'Campo obrigatório caso o tipo de mídia seja vídeo'
              ),
            otherwise: schema => schema.optional(),
          }),
          imageMobile: mixed<RcFile | string>().when('mediaType', {
            is: 'IMAGE',
            then: schema =>
              schema.required(
                'Campo obrigatório caso o tipo de mídia seja imagem'
              ),
            otherwise: schema => schema.optional(),
          }),
          imageWeb: mixed<RcFile | string>().when('mediaType', {
            is: 'IMAGE',
            then: schema =>
              schema.required(
                'Campo obrigatório caso o tipo de mídia seja imagem'
              ),
            otherwise: schema => schema.optional(),
          }),
          redirectButtonUrl: string().when('textButton', {
            is: (textButton: string) => textButton && textButton.length > 0,
            then: schema =>
              schema
                .required(
                  'Este campo é obrigatório caso o texto do botão esteja preenchido'
                )
                .matches(
                  /^https:\/\//,
                  'A URL de redirecionamento deve começar com https://'
                ),
            otherwise: schema => schema.optional(),
          }),
          openExternalWindow: boolean(),
        })
      )
      .min(2, 'O conteúdo do modal deve conter no mínimo 2 itens')
      .required('O conteúdo do modal é obrigatório'),
  }).defined();
